export default __webpack_public_path__ + "b4b102253235a7015c47267245808dfd.jpg";